'use es6';

import AsyncComponentLoading from 'email-management-lib/refactor/components/app/asyncLoaders/AsyncComponentLoading';
import Loadable from 'UIComponents/decorators/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
export default Loadable({
  loader: () => import( /* webpackChunkName: "more-tools-modal" */'./MoreToolsModalContainer'),
  LoadingComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "more-tools-modal"
  }, props)),
  ErrorComponent: props => /*#__PURE__*/_jsx(AsyncComponentLoading, Object.assign({
    bundleName: "more-tools-modal"
  }, props, {
    navMarkerErrorName: "MORE_TOOLS_MODAL_LOAD_FAILED"
  }))
});